module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst {\nrenderHtmlWrapper,\ntitle,\nsubTitle,\nmessage,\nshowErrorCode,\n} = utils.error.prepare(locals)\nif(renderHtmlWrapper)\n{\n%><!doctype html>\n<html lang=\"<%- storage.langCode %>\">\n<head>\n<title><%= title %> | Livecom</title>\n<meta charset=\"utf-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n<meta name=\"title\" content=\"<%= title %>\">\n<%- include('../layouts/master/meta'); %>\n<link rel=\"stylesheet\" href=\"/dist/css/bundle.css\">\n</head>\n<body class=\"errorContainer\">\n<div class=\"container\">\n<div class=\"row\">\n<%\n}\n%>\n<div class=\"col-12 errors_errors\">\n<section><%\nif(renderHtmlWrapper){\n%><a href=\"/\" title=\"Zur Startseite von livecom\"><%\n}\n%><img src=\"/images/logo-livecom.jpg\" width=\"290\" height=\"65\" alt=\"Livecom - Vereinigung der österreichischen Veranstaltungsdienstleister\" class=\"img-fluid\"><%\nif(renderHtmlWrapper){\n%></a><%\n}\n%></section>\n<section><%\nif(title){\n%><h1><%= title %></h1><%\n}\nif(subTitle){\n%><h2><%= subTitle %></h2><%\n}\nif(message){\n%><%- message %><%\n}\n%></section><%\nif(showErrorCode){\n%><section class=\"errorCode\"><%- showErrorCode %></section><%\n}\n%></div>\n<%\nif(renderHtmlWrapper) {\n%>\n</div>\n</div>\n</body>\n</html>\n<%\n}\n%>"
  , __filename = "components\\errors\\errors.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const {
renderHtmlWrapper,
title,
subTitle,
message,
showErrorCode,
} = utils.error.prepare(locals)
if(renderHtmlWrapper)
{

    ; __line = 11
    ; __append("<!doctype html>\n<html lang=\"")
    ; __line = 12
    ; __append( storage.langCode )
    ; __append("\">\n<head>\n<title>")
    ; __line = 14
    ; __append(escapeFn( title ))
    ; __append(" | Livecom</title>\n<meta charset=\"utf-8\">\n<meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n<meta name=\"title\" content=\"")
    ; __line = 17
    ; __append(escapeFn( title ))
    ; __append("\">\n")
    ; __line = 18
    ; __append( include('../layouts/master/meta') )
    ; __append("\n<link rel=\"stylesheet\" href=\"/dist/css/bundle.css\">\n</head>\n<body class=\"errorContainer\">\n<div class=\"container\">\n<div class=\"row\">\n")
    ; __line = 24
    ; 
}

    ; __line = 26
    ; __append("\n<div class=\"col-12 errors_errors\">\n<section>")
    ; __line = 28
    ; 
if(renderHtmlWrapper){

    ; __line = 30
    ; __append("<a href=\"/\" title=\"Zur Startseite von livecom\">")
    ; 
}

    ; __line = 32
    ; __append("<img src=\"/images/logo-livecom.jpg\" width=\"290\" height=\"65\" alt=\"Livecom - Vereinigung der österreichischen Veranstaltungsdienstleister\" class=\"img-fluid\">")
    ; 
if(renderHtmlWrapper){

    ; __line = 34
    ; __append("</a>")
    ; 
}

    ; __line = 36
    ; __append("</section>\n<section>")
    ; __line = 37
    ; 
if(title){

    ; __line = 39
    ; __append("<h1>")
    ; __append(escapeFn( title ))
    ; __append("</h1>")
    ; 
}
if(subTitle){

    ; __line = 42
    ; __append("<h2>")
    ; __append(escapeFn( subTitle ))
    ; __append("</h2>")
    ; 
}
if(message){

    ; __line = 45
    ; __append( message )
    ; 
}

    ; __line = 47
    ; __append("</section>")
    ; 
if(showErrorCode){

    ; __line = 49
    ; __append("<section class=\"errorCode\">")
    ; __append( showErrorCode )
    ; __append("</section>")
    ; 
}

    ; __line = 51
    ; __append("</div>\n")
    ; __line = 52
    ; 
if(renderHtmlWrapper) {

    ; __line = 54
    ; __append("\n</div>\n</div>\n</body>\n</html>\n")
    ; __line = 59
    ; 
}

    ; __line = 61
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components\errors\errors.ejs

}